import { Turbo } from "@hotwired/turbo-rails"

// Styled replacement for window.confirm on data-turbo-confirm actions
// (Approve, Reverse, Lock period, ...). Falls back to native confirm if
// the dialog element is missing.
Turbo.config.forms.confirm = (message) => {
  const dialog = document.getElementById("confirm-dialog")
  if (!dialog) return Promise.resolve(window.confirm(message))

  dialog.querySelector("[data-confirm-message]").textContent = message
  dialog.showModal()
  return new Promise((resolve) => {
    dialog.addEventListener("close", () => resolve(dialog.returnValue === "confirm"), { once: true })
  })
}
